<template>
	<div class="personal-center-container">
		<div class="content-container">
			<BreadCrumb style="margin-top: 0;" :routerLinks="routerLinks" currentTitle="订单详情"></BreadCrumb>
			<div class="orderInfoBox">
				<div class="goodsInfoBox">
					<div class="orderStatus" v-if="$route.query.type == 2">
						{{getMakeStatusName(orderInfo)}}
					</div>
					<div class="buyerTitle">买家信息</div>
					<div class="buyerInfo">
						<div class="buyerInfoTitle">买家昵称：</div>
						{{orderInfo.user && orderInfo.user.user_nickname ? orderInfo.user.user_nickname : ''}}
					</div>
					<div class="buyerInfo">
						<div class="buyerInfoTitle">买家电话：</div>
						{{orderInfo.user && orderInfo.user.mobile ? hideMiddleDigits(orderInfo.user.mobile) : ''}}
					</div>
					<div class="buyerInfo">
						<div class="buyerInfoTitle">买家邮箱：</div>
						{{orderInfo.user && orderInfo.user.user_email ? replaceMiddle4(orderInfo.user.user_email) : ''}}
					</div>
					<div class="goodsInfo" v-if="$route.query.type == 2">
						<div class="descTips">
							<div class="desc">
								{{orderInfo.content ? orderInfo.content : ''}}
							</div>
							<div class="tips">
								<div class="tip" v-if="orderInfo.yongtu">
									{{orderInfo.yongtu}}
								</div>
							</div>
						</div>
						<div class="swiperBox">
							<ImgAallery :images="orderInfo.img" v-if="orderInfo.img && orderInfo.img.length" />
						</div>
					</div>
					<div class="buyerTitle">订单设置</div>
					<div class="gongqiBox"
						v-if="orderInfo.status == 3 || orderInfo.status == 4 || orderInfo.status == 5">
						<div class="gongqiTitle">工期说明</div>
						<div class="gongqiContent">{{orderInfo.hs_gongqi ? orderInfo.hs_gongqi : ''}}</div>
					</div>
					<div class="gongqiBox" style="margin-top: .16rem;"
						v-if="orderInfo.status == 3 || orderInfo.status == 4 || orderInfo.status == 5">
						<div class="gongqiTitle">备注</div>
						<div class="gongqiContent">{{orderInfo.hs_content ? orderInfo.hs_content : ''}}</div>
					</div>
					<el-form ref="baseInfoForm" hide-required-asterisk class="register-form" :model="baseInfoForm"
						:rules="baseInfoRules" inline v-if="orderInfo.status == 1 || orderInfo.status == 2">
						<el-form-item label="订单金额：" prop="order_price">
							<div class="form-group" style="width: 4.1rem;">
								<input type="text" v-model="baseInfoForm.order_price" placeholder="请输入订单金额"
									class="form-input" @input="onAmountInput" />
							</div>
						</el-form-item>
						<el-form-item label="工期说明：" prop="hs_gongqi">
							<div class="form-group" style="width: 7.05rem;">
								<div class="contentBox">
									<textarea v-model="baseInfoForm.hs_gongqi" placeholder="请输入工期说明"></textarea>
									<div class="textNum">
										{{baseInfoForm.hs_gongqi ? baseInfoForm.hs_gongqi.length : 0}}/ <span>200</span>
									</div>
								</div>
							</div>
						</el-form-item>
						<el-form-item label="备注：" prop="hs_content">
							<div class="form-group" style="width: 7.05rem;">
								<div class="contentBox">
									<textarea v-model="baseInfoForm.hs_content" placeholder="请输入备注"></textarea>
									<div class="textNum">
										{{baseInfoForm.hs_content ? baseInfoForm.hs_content.length : 0}}/
										<span>200</span>
									</div>
								</div>
							</div>
						</el-form-item>
						<button type="button" @click="register('baseInfoForm')" class="register-btn">确认订单</button>
					</el-form>
				</div>
				<div class="payInfoBox" v-if="$route.query.type == 1">
					<div class="title">
						订单信息
					</div>
					<div class="orderPriceBox">
						<div class="itemTitle">订单金额</div>
						<div class="priceBox" style="margin-right: .1rem;">
							<div class="price">
								<span class="unit">¥</span>
								69.9
							</div>
						</div>
					</div>
					<div class="orderPriceBox" @click="dialogCouponVisible = true">
						<div class="itemTitle">代金券</div>
						<div class="priceBox">
							<div class="price">
								<span class="unit">¥</span>
								69.9
							</div>
							<img class="arrow" src="../../assets/BuyNow/iconI.png" />
						</div>
					</div>
					<div class="payWayBox">
						<div class="payItem">
							<img class="checkIcon" src="../../assets/BuyNow/iconF.png" />
							<!-- <img class="checkIcon" src="../../assets/BuyNow/iconC.png" /> -->
							<img class="payIcon" src="../../assets/BuyNow/iconE.png" />
							微信支付
						</div>
						<div class="payItem">
							<!-- <img class="checkIcon" src="../../assets/BuyNow/iconF.png" /> -->
							<img class="checkIcon" src="../../assets/BuyNow/iconC.png" />
							<img class="payIcon" src="../../assets/BuyNow/iconD.png" />
							支付宝支付
						</div>
					</div>
					<div class="agreementBox">
						<img class="checkIcon" src="../../assets/BuyNow/iconH.png" />
						<!-- <img class="checkIcon" src="../../assets/BuyNow/iconA.png" /> -->
						我已阅读并同意 <span class="userAgreement" @click="userBuy = true">《用户购买须知协议》</span>
					</div>
					<div class="costButNow">
						<div class="costBox">
							实付款
							<div class="cost">
								<span class="unit">¥</span>
								69.8
							</div>
						</div>
						<div class="buyNow">立即购买</div>
					</div>
				</div>
				<div class="orderFinishInfoBox" v-if="$route.query.type == 2">
					<div class="title" v-if="orderInfo.status && orderInfo.status != 1">
						付款详情
					</div>
					<div class="priceBox" v-if="orderInfo.status && orderInfo.status != 1">
						<div class="priceItem">
							商品总价
							<span>¥{{orderInfo.order_price ? orderInfo.order_price : '0'}}</span>
						</div>
						<div class="priceItem">
							优惠
							<span>¥{{orderInfo.coupon_price ? orderInfo.coupon_price : '0'}}</span>
						</div>
						<div class="priceItem">
							实付款
							<span class="cost">¥ {{orderInfo.pay_price ? orderInfo.pay_price : '0'}}</span>
						</div>
						<div class="priceItem">
							订单分润收入
							<span class="cost">¥
								{{orderInfo.out_refund_no ? (orderInfo.tk_hs_price ?  orderInfo.tk_hs_price  : '0') : (orderInfo.hs_price ? orderInfo.hs_price : '0')}}</span>
						</div>
					</div>
					<div class="title" style="margin-top: .08rem;">
						订单信息
					</div>
					<div class="orderTimeBox">
						<div class="orderTimeItem">
							创建时间
							<span>{{orderInfo.create_time ? orderInfo.create_time : ''}}</span>
						</div>
						<div class="orderTimeItem" v-if="orderInfo.status && orderInfo.status == 4">
							成交时间
							<span>{{orderInfo.create_time ? orderInfo.create_time : ''}}</span>
						</div>
					</div>
					<div class="service" @click="$router.push(`/painter-chat?userId=${orderInfo.user_id}`)">
						联系买家</div>
					<div class="uploadLook" v-if="orderInfo.status && orderInfo.status == 3"
						@click="dialogHDImgVisible = true">
						上传高清图</div>
					<div class="uploadLook" style="position: relative;"
						v-if="orderInfo.status && (orderInfo.status == 4 || orderInfo.status == 5)">
						<el-image style="width: 2.4rem;height: .52rem;position: absolute;top: 0;left: 0;opacity: 0;"
							:src="orderInfo.yt_img && orderInfo.yt_img.length > 0 ? orderInfo.yt_img[0] : ''"
							:preview-src-list="orderInfo.yt_img">
						</el-image>
						查看高清图
					</div>
				</div>
				<!-- <div class="orderFinishInfoBox" v-if="$route.query.type == 3">
					<div class="title">
						付款详情
					</div>
					<div class="priceBox">
						<div class="priceItem">
							商品总价
							<span>¥{{orderInfo.order && orderInfo.order.order_price ? orderInfo.order.order_price : '0'}}</span>
						</div>
						<div class="priceItem">
							优惠
							<span>¥{{orderInfo.order && orderInfo.order.coupon_price ? orderInfo.order.coupon_price : '0'}}</span>
						</div>
						<div class="priceItem">
							实付款
							<span class="cost">¥
								{{orderInfo.order && orderInfo.order.pay_price ? orderInfo.order.pay_price : '0'}}</span>
						</div>
					</div>
					<div class="title" style="margin-top: .08rem;">
						订单信息
					</div>
					<div class="orderTimeBox">
						<div class="orderTimeItem">
							创建时间
							<span>{{orderInfo.order && orderInfo.order.create_time ? orderInfo.order.create_time : ''}}</span>
						</div>
						<div class="orderTimeItem">
							成交时间
							<span>{{orderInfo.order && orderInfo.order.create_time ? orderInfo.order.create_time : ''}}</span>
						</div>
					</div>
					<div class="service" @click="severPop = true">立即咨询</div>
				</div> -->
				<!-- <div class="orderFinishInfoBox" v-if="$route.query.type == 4">
					<div class="title">
						付款详情
					</div>
					<div class="priceBox">
						<div class="priceItem">积分总额
							<span>{{orderInfo.order && orderInfo.order.order_price ? orderInfo.order.order_price : '0'}}积分</span>
						</div>
						<div class="priceItem">兑换数量
							<span>{{orderInfo.order && orderInfo.order.num ? orderInfo.order.num : '0'}}</span>
						</div>
					</div>
					<div class="priceBox">
						<div class="priceItem">商品总价 <span>¥ 69.8</span></div>
						<div class="priceItem">优惠 <span>¥ 69.8</span></div>
						<div class="priceItem">实付款 <span class="cost">¥ 69.8</span></div>
					</div>
					<div class="title" style="margin-top: .08rem;">
						订单信息
					</div>
					<div class="orderTimeBox">
						<div class="orderTimeItem">创建时间
							<span>{{orderInfo.order && orderInfo.order.create_time ? orderInfo.order.create_time : ''}}</span>
						</div>
						<div class="orderTimeItem">成交时间
							<span>{{orderInfo.order && orderInfo.order.create_time ? orderInfo.order.create_time : ''}}</span>
						</div>
					</div>
					<div class="service" @click="severPop = true">立即咨询</div>
				</div> -->
			</div>
		</div>
		<div class="severInfoPop" v-if="severPop">
			<div class="centerContent">
				<img class="sveerIcon" src="../../assets/Home/sveerIcon.png" />
				<div class="email">
					客服邮箱：{{email}}
				</div>
				<div class="QQ">
					客服 QQ：{{qqNum}}
				</div>
				<div class="ok" @click="severPop = false">
					好的
				</div>
			</div>
		</div>
		<UserBuyAgreeDialog :show="userBuy" @close="userBuy = false" />
		<UploadHDImg :show="dialogHDImgVisible" :orderId="orderInfo.id" @close="dialogHDImgVisible = false"
			@uploadSuc="sucPop = true;desc = '提交成功！';makeOrderOetails()" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="desc" @clickOk="sucPop = false;"
			v-if="sucPop" />
	</div>
</template>

<script>
	import PopToast from '../../components/PopToast.vue'
	import ImgAallery from '../../components/ImgAallery.vue'
	import UploadHDImg from '../../components/UploadHDImg.vue'
	import UserBuyAgreeDialog from '../../components/UserBuyAgreeDialog.vue'
	export default {
		name: 'OrderDetails',
		components: {
			PopToast,
			ImgAallery,
			UploadHDImg,
			UserBuyAgreeDialog
		},
		data() {
			return {
				desc: '',
				sucPop: false,
				baseInfoForm: {
					hs_gongqi: '',
					hs_content: '',
					order_price: '',
				},
				dialogHDImgVisible: false,
				baseInfoRules: {
					order_price: [{
						required: true,
						message: '请输入订单金额',
						trigger: 'blur'
					}],
					hs_gongqi: [{
						required: true,
						message: '请输入工期说明',
						trigger: 'blur'
					}],
				},
				userBuy: false,
				email: '',
				qqNum: '',
				severPop: false,
				orderInfo: {},
				routerLinks: [{
					path: '/painter-make-order',
					title: '图片订单',
					query: {}
				}],
			}
		},
		mounted() {
			this.configData()
			this.makeOrderOetails()
		},
		methods: {
			onAmountInput(e) {
				let val = e.target.value;
				// 1. 只允许数字和小数点
				val = val.replace(/[^\d.]/g, "");
				// 2. 开头不能是多个 0
				// 如果以 "0" 开头，并且第二位不是 "."，例如 01、012 → 去掉前导 0
				if (/^0\d+/.test(val)) {
					val = val.replace(/^0+/, "");
				}
				// 3. 开头是 "." 的情况 → 自动补 0
				if (val.startsWith(".")) {
					val = "0" + val;
				}
				// 4. 只保留第一个小数点
				val = val.replace(/\.{2,}/g, ".");
				val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				// 5. 最多两位小数
				val = val.replace(/^(\d+)\.(\d{0,2}).*$/, "$1.$2");
				this.baseInfoForm.order_price = val;
				e.target.value = val;
			},
			replaceMiddle4(str) {
				const len = str.length;
				const middle = Math.floor(len / 2) - 2; // 中心向前偏移两位
				return str.substring(0, middle) + "****" + str.substring(middle + 4);
			},
			hideMiddleDigits(phoneNumber) {
				if (typeof phoneNumber === 'string' && phoneNumber.length === 11) {
					// 将中间四位替换为星号
					return phoneNumber.slice(0, 3) + '****' + phoneNumber.slice(7);
				}
			},
			register(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/Hua/dz_order_confirm', {
							...this.baseInfoForm,
							id: this.orderInfo.id
						}).then(res => {
							if (res.code == 1) {
								this.baseInfoForm = {
									hs_gongqi: '',
									hs_content: '',
									order_price: '',
								}
								this.desc = '确认订单成功！'
								this.sucPop = true
								this.makeOrderOetails()
							} else {
								this.$message.error(res.msg)
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
			configData() {
				this.$api.post('/Other/config', {}).then(res => {
					if (res.code == 1) {
						res.data.forEach(item => {
							if (item.title == 'kf_email') {
								this.email = item.value
							}
							if (item.title == 'kf_qq') {
								this.qqNum = item.value
							}
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			makeOrderOetails() {
				this.$api.post('/Hua/dz_order_detail', {
					id: this.$route.query.orderId
				}).then(res => {
					if (res.code == 1) {
						this.orderInfo = res.data
						this.baseInfoForm = {
							hs_gongqi: this.orderInfo.hs_gongqi,
							hs_content: this.orderInfo.hs_content,
							order_price: this.orderInfo.status == 1 ? '' : this.orderInfo.order_price,
						}
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//定制图片订单获取订单状态
			getMakeStatusName(item) {
				if (item.status == 1) {
					return '画师待确认'
				} else if (item.status == 2) {
					return '待支付'
				} else if (item.status == 3) {
					return '创作中'
				} else if (item.status == 4) {
					return '已完成'
				} else if (item.status == 5) {
					return item.out_refund_no ? '已退款' : '已取消'
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.personal-center-container {
		margin: .24rem .24rem;
		display: flex;
		flex-direction: column;
		border-radius: .08rem;
	}

	.content-container {
		width: 12rem;
		display: flex;
		flex-direction: column;
		z-index: 1;
	}

	.orderInfoBox {
		margin-top: .16rem;
		display: flex;
		justify-content: space-between;

		.goodsInfoBox {
			display: flex;
			flex-direction: column;
			width: 8.95rem;
			padding: .32rem .24rem .24rem;
			background: #FFFFFF;
			box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
			border-radius: .12rem;
		}

		.orderStatus {
			padding-bottom: .24rem;
			border-bottom: .01rem solid #CCCCCC;
			font-weight: 700;
			font-size: .24rem;
			color: #000000;
			line-height: .32rem;
		}

		.buyerTitle {
			margin-top: .24rem;
			margin-bottom: .16rem;
			font-weight: 600;
			font-size: .16rem;
			color: #333333;
			line-height: .22rem;
		}

		.buyerInfo {
			display: flex;
			align-items: center;
			height: .32rem;
			font-weight: 500;
			font-size: .16rem;
			color: #333333;
			line-height: .32rem;

			.buyerInfoTitle {
				width: .8rem;
				font-weight: 400;
			}
		}

		.addressInfoBox {
			margin-top: .24rem;
			display: flex;
			align-items: center;

			.icon {
				width: .32rem;
				height: .32rem;
			}

			.addressInfo {
				margin-left: .12rem;
				display: flex;
				flex-direction: column;

				.address {
					font-weight: 500;
					font-size: .14rem;
					color: #1C1C1C;
				}

				.namePhone {
					margin-top: .02rem;
					font-weight: 400;
					font-size: .12rem;
					color: #1C1C1C;
				}
			}
		}

		.userInfoBox {
			margin-top: .24rem;
			display: flex;
			align-items: center;

			.avatar {
				width: .44rem;
				height: .44rem;
				border-radius: 50%;
				overflow: hidden;
				object-fit: cover;
			}

			.nickname {
				margin-left: .16rem;
				font-weight: 500;
				font-size: .18rem;
				color: #312C28;
			}
		}

		.integralOrder {
			margin-top: .24rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-top: .24rem;
			border-top: .01rem solid #CCCCCC;

			.imgInfoBox {
				display: flex;
				align-items: center;

				.makeGoodsImg {
					width: 1rem;
					height: 1rem;
					border-radius: .08rem;
					overflow: hidden;
					object-fit: cover;
				}

				.imgInfo {
					width: 2.4rem;
					margin-left: .16rem;
					display: flex;
					flex-direction: column;

					.goodsTitle {
						font-weight: 700;
						font-size: .16rem;
						color: #000000;
						line-height: .22rem;
					}

					.goodsDesc {
						margin-top: .08rem;
						font-weight: 400;
						font-size: .12rem;
						color: #999999;
						line-height: .16rem;
					}
				}
			}

			.goodsPrice {
				display: flex;
				flex-direction: column;
				align-items: flex-end;

				.price {
					display: flex;
					align-content: center;
					font-weight: 400;
					font-size: .14rem;
					color: #000000;
				}

				.num {
					font-weight: 400;
					font-size: .12rem;
					color: #999999;
				}
			}
		}

		.imgOrder {
			margin-top: .24rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-top: .24rem;
			border-top: .01rem solid #CCCCCC;

			.imgInfoBox {
				display: flex;
				align-items: center;

				.makeGoodsImg {
					width: 1rem;
					height: 1rem;
					border-radius: .08rem;
					overflow: hidden;
					object-fit: cover;
				}

				.goodsImg {
					width: .76rem;
					height: 1.02rem;
					border-radius: .08rem;
					overflow: hidden;
					object-fit: cover;
				}

				.imgInfo {
					width: 5rem;
					margin-left: .16rem;
					display: flex;
					flex-direction: column;

					.goodsTitle {
						font-weight: 700;
						font-size: .16rem;
						color: #000000;
						line-height: .22rem;
					}

					.goodsDesc {
						margin-top: .08rem;
						font-weight: 400;
						font-size: .12rem;
						color: #333333;
						line-height: .16rem;
					}

					.tips {
						margin-top: .12rem;
						display: flex;
						align-items: center;

						.tip {
							height: .26rem;
							padding: 0 .08rem;
							border-radius: .13rem;
							border: .01rem solid #A88653;
							line-height: .24rem;
							font-weight: 400;
							font-size: .12rem;
							color: #7C3E0B;
						}
					}
				}
			}

			.goodsPrice {
				display: flex;
				flex-direction: column;
				align-items: flex-end;

				.price {
					display: flex;
					align-content: center;
					font-weight: 700;
					font-size: .14rem;
					color: #000000;

					span {
						font-weight: 400;
					}
				}

				.num {
					font-weight: 400;
					font-size: .12rem;
					color: #999999;
				}
			}
		}

		.goodsInfo {
			margin-top: .24rem;
			display: flex;
			align-items: center;
			padding-top: .24rem;
			border-top: .01rem solid #CCCCCC;
			padding-bottom: .24rem;
			border-bottom: .01rem solid #CCCCCC;

			.descTips {
				display: flex;
				flex-direction: column;

				.desc {
					width: 3.68rem;
					font-weight: 400;
					font-size: .12rem;
					color: #333333;
				}

				.tips {
					margin-top: .12rem;
					display: flex;
					align-items: center;

					.tip {
						height: .26rem;
						padding: 0 .08rem;
						border-radius: .13rem;
						border: .01rem solid #A88653;
						line-height: .24rem;
						font-weight: 400;
						font-size: .12rem;
						color: #7C3E0B;
					}
				}
			}
		}

		.timeBox {
			margin-top: .24rem;
			width: 8.47rem;
			display: flex;
			flex-direction: column;
			background: #FAEFDD;
			padding: .16rem .16rem;
			border-radius: .06rem;

			.timeTitle {
				font-weight: 700;
				font-size: .14rem;
				color: #333333;
			}

			.timeDesc {
				margin-top: .06rem;
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
			}
		}
	}

	.orderFinishInfoBox {
		display: flex;
		align-self: self-start;
		flex-direction: column;
		width: 2.88rem;
		background: #FFFFFF;
		padding: .24rem .24rem;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;

		.title {
			margin-bottom: .06rem;
			font-weight: 600;
			font-size: .16rem;
			color: #333333;
			line-height: .22rem;
		}

		.priceBox {
			display: flex;
			flex-direction: column;

			.priceItem {
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-weight: 400;
				font-size: .14rem;
				color: #333333;

				span {
					font-weight: 600;
					font-size: .14rem;
					color: #333333;
				}

				.cost {
					font-weight: 700;
					font-size: .2rem;
				}
			}
		}

		.orderTimeBox {
			display: flex;
			flex-direction: column;

			.orderTimeItem {
				margin-top: .08rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
			}
		}

		.service {
			margin: .32rem auto 0;
			width: 2.4rem;
			height: .52rem;
			background: #E29358;
			border-radius: .06rem;
			font-weight: 500;
			font-size: .16rem;
			color: #252525;
			line-height: .52rem;
			text-align: center;
			cursor: pointer;
		}

		.uploadLook {
			margin: .16rem auto 0;
			width: 2.4rem;
			height: .52rem;
			border: .01rem solid #E29358;
			border-radius: .06rem;
			font-weight: 500;
			font-size: .16rem;
			color: #E29358;
			line-height: .52rem;
			text-align: center;
			cursor: pointer;
		}
	}

	.payInfoBox {
		display: flex;
		align-self: flex-start;
		flex-direction: column;
		width: 2.88rem;
		background: #FFFFFF;
		padding: .24rem .24rem;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;

		.title {
			margin-bottom: .06rem;
			font-weight: 600;
			font-size: .16rem;
			color: #333333;
			line-height: .22rem;
		}

		.orderPriceBox {
			margin-top: .1rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.itemTitle {
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
			}

			.priceBox {
				display: flex;
				align-items: center;

				.price {
					display: flex;
					align-items: baseline;
					font-weight: 700;
					font-size: .2rem;
					color: #FF0100;

					.unit {
						font-weight: 400;
						font-size: .14rem;
					}
				}


				.arrow {
					margin-left: .04rem;
					width: .06rem;
					height: .1rem;
				}
			}
		}

		.payWayBox {
			margin-top: .24rem;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: 2.4rem;
			height: .96rem;
			background: #FFFFFF;
			border-radius: .08rem;
			border: .01rem solid #EFD8B8;
			padding: .2rem .16rem;

			.payItem {
				display: flex;
				align-items: center;
				font-weight: 500;
				font-size: .14rem;
				color: #333333;
				line-height: .2rem;

				.checkIcon {
					margin-right: .16rem;
					width: .14rem;
					height: .14rem;
				}

				.payIcon {
					margin-right: .06rem;
					width: .16rem;
					height: .16rem;
				}
			}
		}

		.agreementBox {
			margin-top: .12rem;
			display: flex;
			align-items: center;
			font-size: .12rem;

			.checkIcon {
				margin-right: .06rem;
				width: .14rem;
				height: .14rem;
			}

			.userAgreement {
				color: #E29358;
				cursor: pointer;
			}
		}

		.costButNow {
			margin-top: .4rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.costBox {
				display: flex;
				flex-direction: column;
				font-weight: 400;
				font-size: .12rem;
				color: #333333;

				.cost {
					display: flex;
					align-items: baseline;
					font-weight: 700;
					font-size: .24rem;
					color: #FF0000;

					.unit {
						font-weight: 400;
						font-size: .14rem;
					}
				}
			}

			.buyNow {
				width: 1rem;
				height: .48rem;
				background: #E29358;
				border-radius: .06rem;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
				line-height: .48rem;
				text-align: center;
			}
		}
	}

	.severInfoPop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 100;

		.centerContent {
			display: flex;
			flex-direction: column;
			width: 3.1rem;
			background: #FFFFFF;
			border-radius: .12rem;

			.sveerIcon {
				width: .64rem;
				height: .64rem;
				margin: .4rem auto 0;
			}

			.email,
			.QQ {
				margin-top: .24rem;
				margin-left: .24rem;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
			}

			.ok {
				margin: .24rem auto;
				width: 1.76rem;
				height: .36rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				text-align: center;
				line-height: .36rem;
				cursor: pointer;
			}
		}
	}

	.register-form {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: .16rem .6rem 0 0;
		font-weight: 400;
		font-size: .16rem;
		color: #252525;
	}

	.form-group {
		display: flex;
		align-items: center;
		width: 5.48rem;
	}

	.form-input {
		width: 4.24rem;
		height: 0.44rem;
		border: .01rem solid #EFD8B8;
		border-radius: 0.04rem;
		padding: 0 0.16rem;
		font-size: 0.14rem;
		color: #333333;
		outline: none;
		transition: border-color 0.3s ease;

		// &:focus {
		// 	border-color: #E29358;
		// }

		&::placeholder {
			color: #999999;
		}
	}

	.contentBox {
		width: 100%;
		height: 1rem;
		background: #FFFFFF;
		border-radius: .04rem;
		border: .01rem solid #EFD8B8;
		padding: .12rem .12rem;
		position: relative;

		textarea {
			width: 100%;
			height: 100%;
			font-size: .14rem;
			padding: 0 0;
			border: none;
		}

		.textNum {
			position: absolute;
			right: .12rem;
			bottom: .08rem;
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: #252525;
			line-height: .2rem;
			background: #FFFFFF;

			span {
				color: #999999;
			}
		}
	}

	.register-btn {
		margin: .08rem auto 0;
		width: 1.22rem;
		height: 0.36rem;
		background: #E29358;
		padding: 0 0;
		border: none;
		border-radius: 0.04rem;
		font-weight: 500;
		font-size: 0.12rem;
		color: #252525;
		font-weight: 500;
		line-height: .36rem;
		cursor: pointer;
		transition: background 0.3s ease;

		&:hover {
			background: #D17F3A;
		}
	}

	::v-deep .el-form-item {
		margin-right: 0 !important;
		margin-bottom: .16rem !important;
		font-size: .14rem;
		line-height: 0.44rem;

		&__label {
			padding: 0 0;
			width: .7rem;
			height: 0.44rem;
			line-height: .44rem;
			font-size: .14rem;
		}

		&__content {
			font-size: .14rem;
			line-height: 0.44rem;
		}

		&__error {
			font-size: .12rem;
			padding-top: .02rem;
		}
	}

	.gongqiBox {
		display: flex;
		align-items: flex-start;

		.gongqiTitle {
			width: .7rem;
			height: 0.22rem;
			line-height: .2rem;
			font-size: .14rem;
		}

		.gongqiContent {
			width: 7.05rem;
			font-size: .14rem;
			line-height: .2rem;
		}
	}
</style>